module.exports = __webpack_public_path__ + "static/media/OFF.38337667.svg";